import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { lionSelectors } from '@rosetta/react-lion';
import PropTypes from 'prop-types';
import { TooltipContainer as Tooltip } from './Tooltip';
import { appSelectors } from '../reducer/app-reducer';

let isRtl = false;

const Icon = styled.div`
  background: #dfdfdf;
  color: #fff;
  font-size: 9px;
  border-radius: 20px;
  height: 12px;
  width: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 1px;
  position: relative;
  top: -3px;
  right: ${isRtl ? 'auto' : '-5px'};
  font-family: NotoSans;
`;

//*********************************************
class HelpButton extends PureComponent {
  componentWillMount = () => {
    this.setState({
      showingTooltip: false
    });
  };

  showTooltip = () => {
    this.setState({
      showingTooltip: true
    });
  };

  hideTooltip = () => {
    this.setState({
      showingTooltip: false
    });
  };

  render = () => {
    isRtl = this.props.isInterfaceRtl;

    let tooltip = null;
    if (this.props.lionLoaded && this.state.showingTooltip) {
      tooltip = <Tooltip tipText={this.props.tipText} tippedElement={this} tipPosition={this.props.tipPosition} />;
    }
    return (
      <Icon onMouseOver={this.showTooltip} onMouseOut={this.hideTooltip}>
        ? {tooltip}
      </Icon>
    );
  };
}

HelpButton.propTypes = {
  helpTextKey: PropTypes.string.isRequired,
  tipPosition: PropTypes.string.isRequired
};

const mapStateToProps = (state, ownprops) => ({
  isInterfaceRtl: appSelectors.isInterfaceRtl(state),
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  }
});

const wrapActions = {};
export const HelpIconContainer = connect(
  mapStateToProps,
  wrapActions
)(HelpButton);



// WEBPACK FOOTER //
// ./src/modules/app/util/HelpIcon.jsx